import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ContactSection, HeroSection, LandingFooter, LandingHeader, ProductsSection, SitesSection, WhySection,
  copy, CONTACT, useReveal,
} from '../components/landing';

const LANG_KEY = 'valhalla_landing_lang';

function initialLanguage() {
  try {
    const saved = localStorage.getItem(LANG_KEY);
    if (saved === 'es' || saved === 'en') return saved;
  } catch {
    // storage may be blocked; use the default
  }
  return 'es';
}

export default function LandingPage() {
  const navigate = useNavigate();
  const [lang, setLang] = useState(initialLanguage);
  const text = copy[lang];

  useReveal(lang);

  useEffect(() => {
    document.documentElement.lang = lang;
    try { localStorage.setItem(LANG_KEY, lang); } catch { /* ignore */ }
  }, [lang]);

  const goToLogin = useCallback(() => navigate('/login'), [navigate]);
  const toggleLang = useCallback(() => setLang((current) => (current === 'es' ? 'en' : 'es')), []);
  const requestDemo = useCallback(() => {
    const subject = encodeURIComponent(`${text.contact.subjectPrefix} ${text.contact.interests.lifetide}`);
    window.location.href = `mailto:${CONTACT.email}?subject=${subject}`;
  }, [text]);

  return (
    <div className="font-landing bg-[#F8F6F0] text-[#0A0A0A] antialiased">
      <LandingHeader copy={text} lang={lang} onToggleLang={toggleLang} onLogin={goToLogin} />
      <main>
        <HeroSection copy={text} />
        <ProductsSection copy={text} onOpenErp={goToLogin} onRequestDemo={requestDemo} />
        <SitesSection copy={text} />
        <WhySection copy={text} />
        <ContactSection copy={text} />
      </main>
      <LandingFooter copy={text} onLogin={goToLogin} />
    </div>
  );
}

